/// <reference path="../app.ts" />
/// <reference path="../security/accountService.ts" />
namespace Cfnc {
    "use strict";

    interface IProfileScope extends ng.IScope {
        vm: Profile;
    }

    interface IProfile {

    }

    enum Roles {
        MiddleSchool = 1 << 0, // 1
        HighSchool = 1 << 1, // 2
        College = 1 << 2, // 4
        AdultLearner = 1 << 3, // 8
        Parent = 1 << 4, // 16
        EducationProfessional = 1 << 5, // 32
        NC529AccountHolder = 1 << 6, // 64
        EducationLoanBorrower = 1 << 7 // 128
    };

    class Address implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    class VerifyAddressResults implements IVerifyAddressResultsViewModel {
        firstName: string;
        lastName: string;
        action: string;
        providedAddressHasErrors: boolean;
        key: string;
        providedAddress: Address;
        suggestedAddress: Address;

    }

    class UserProfile implements IUserProfile {
        addressVerified: boolean;
        associatedSchools: Array<ICustomerViewModel>;
        comments: Array<any>;
        customer: ICustomerViewModel;
        dateOfBirth: string;
        daytimePhone: string;
        email: string;
        enrollmentStatus: number;
        eveningPhone: string;
        firstName: string;
        fromServer: boolean;
        gender: number;
        graduationYear: number;
        id: number;
        lastName: string;
        mailAddress: IAddress;
        mailingPhone: string;
        middleName: string;
        nickname: string;
        permAddress: IAddress;
        phoneNumber: string;
        primaryConnectionCrmId: number;
        role: any;
        socialSecurityNumber: string;
        studentId: string;
        suffix: string;
        userContactInfo: any;
        username: string;
        mobilePhone: string;
        homePhone: string;
        workPhone: string;
        emailInvalid: boolean;
        addressInvalid: boolean;
        phoneNumberInvalid: boolean;
        passwordInvalid: boolean;
        textingOptIns: ITextingOptIns;
        emailIsValid: boolean;
        emailVerified: boolean;
        emailSignature: string;
        tin: string;
    }

    class Profile implements IProfile {
        static controllerId: string = "profile";
        static $inject: Array<string> = ["$scope", "$location", "$window", "common", "Restangular", "$timeout", "addressService", "config", "$uibModal"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        maxDate = new Date();
        gradYears: any;
        editingRole: boolean = false;
        editingDetails: boolean = false;
        savingDetails: boolean = false;
        savingDemographics: boolean = false;
        savingParentGuardian: boolean = false;
        editingDemographics: boolean = false;
        newRole: string;
        addressError: boolean = false;
        user: UserProfile;
        originalUser: any;
        selectedGradYear: any = { value: 0 };
        mailingSameAsPerm: boolean;
        melissaDataResponse: any;
        password: any = { oldPassword: "", newPassword: "", confirmPassword: "" };
        showChangePassword: boolean;
        demographics: any;
        originalDemographics: any;
        countries: Array<any>;
        parentGuardian: any;
        editingParentGuardian: boolean;
        originalParentGuardian: any;
        userSecurityQuestion: string;
        userSecurityAnswer: string;
        originalUserSecurityQuestion: string;
        showChangeSecurityQuestion: boolean = false;
        gender: string;
        primaryConnection: any;
        editingPrimaryConnection: boolean = false;
        originalEmail: string;
        loading: boolean;
        noSchoolAssociated: ICustomerViewModel;
        ncCounties: Array<IAddressListItem>;
        newPhoneNumbersEnabled: boolean;
        validSSN: boolean;
        invalidSSNs: any;
        maskedSSN: any;
        maskedConfirmSSN: any;
        umbracoUrl: string;
        authUrl: string;
        slickConfig: any;
        roles: Array<any>;
        roleValues: Array<any>;
        convertedRoles: Array<any>;
        newSSN: any;
        displaySSN: any;
        editSSN: boolean;

        constructor(private $scope: IProfileScope,
            private $location: ng.ILocationService,
            private $window: ng.IWindowService,
            private common: ICommonFactory,
            private Restangular: Restangular.IService,
            private $timeout: ng.ITimeoutService,
            private addressService: IAddressService,
            private config: IConfig,
            private $uibModal: ng.ui.bootstrap.IModalService) {

            this.log = common.logger.getLogFn(Profile.controllerId);
            this.logError = common.logger.getLogFn(Profile.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(Profile.controllerId, "success");
            this.noSchoolAssociated = {
                id: 424273588,
                name: "No School Associated",
                crmId: 218919,
                ceeb_code: null
            };

            this.convertedRoles = [];
            this.roles = [{ value: 1, name: "Middle School or Junior High School Student" },
            { value: 2, name: "High School Student" },
            { value: 4, name: "College or Postsecondary School Student" },
            { value: 8, name: "Adult" },
            { value: 16, name: "Parent" },
            { value: 32, name: "Education Professional" },
            { value: 64, name: "NC 529 Account Holder" },
            { value: 128, name: "Education Loan Borrower" },
            ];

            this.ncCounties = this.addressService.ncCountyList;
            this.newPhoneNumbersEnabled = this.config.newPhoneNumbersEnabled == "npne-true";

            this.umbracoUrl = this.config.umbracoUrl;
            this.authUrl = this.config.authHost
            this.slickConfig = {
                slidesToShow: 3,
                dots: false,
                arrows: false,
                centerMode: true,
                infinite: false,
                variableWidth: true,
                focusOnSelect: true
            };

            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });
            this.editSSN = false;
            this.newSSN = '';
        }

        activate() {
            this.loading = true;
            var promises = [this.getProfile(), this.getDemographics(), this.getParentGuardianInfo()];
            this.common.activateController(promises, Profile.controllerId)
                .then(() => {
                    this.log("Activated Profile View");
                    this.loading = false;
                    this.validSSN = true;

                    this.invalidSSNs = [
                        "000000000",
                        "111111111",
                        "222222222",
                        "333333333",
                        "444444444",
                        "555555555",
                        "666666666",
                        "777777777",
                        "888888888",
                        "999999999",
                        "002281852",
                        "042103580",
                        "062360749",
                        "078051120",
                        "095073645",
                        "123456789",
                        "128036045",
                        "135016629",
                        "141186941",
                        "165167999",
                        "165187999",
                        "165207999",
                        "165227999",
                        "165247999",
                        "189092294",
                        "212097694",
                        "219099998",
                        "306302348",
                        "308125070",
                        "468288779",
                        "549241889",
                        "987654320"
                    ];
                });


            var config = new Config();
            this.getSecurityQuestion()

        }

        getProfile = () => {
            return this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        this.displaySSN = this.user.socialSecurityNumber;
                        this.originalUser = _.cloneDeep(this.user);
                        this.gender = this.user.gender.toString();
                        this.user.customer = this.user.customer == null ? this.noSchoolAssociated : this.user.customer;
                        this.primaryConnection = this.user.customer;
                        this.selectedGradYear.value = this.user.graduationYear;
                        this.gradYears = this.createGraduationYears();
                        this.originalEmail = this.user.email;
                        this.user.permAddress = this.user.permAddress || new Address();
                        this.user.mailAddress = this.user.mailAddress || new Address();
                        this.user.permAddress.userOverride = false;
                        this.user.mailAddress.userOverride = false;
                        this.getRoles();
                        this.maskSSN();
                    }
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        };

        getDemographics = () => {
            return this.Restangular.one("users/demographics").get()
                .then((result) => {
                    this.demographics = result || {};
                    if (result) {
                        this.demographics.disabilities = this.demographics.disabilities ? this.demographics.disabilities.split(",") : [];
                        this.demographics.militaryServices = this.demographics.militaryServices ? this.demographics.militaryServices.split(",") : [];
                        this.demographics.nationalities = this.demographics.nationalities ? this.demographics.nationalities.split(",") : [];
                        this.demographics.ethnicities = this.demographics.ethnicities ? this.demographics.ethnicities.split(",") : [];
                        this.originalDemographics = _.cloneDeep(this.demographics);
                    }
                    else {
                        this.demographics.disabilities = [];
                        this.demographics.militaryServices = [];
                        this.demographics.nationalities = [];
                        this.demographics.ethnicities = [];
                    }
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        };

        getParentGuardianInfo = () => {
            return this.Restangular.one("users/parentguardianinfo").get()
                .then((result) => {
                    this.parentGuardian = result;
                    this.originalParentGuardian = _.cloneDeep(this.parentGuardian);
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        };


        createGraduationYears = (): any[] => {
            var startYear: number = moment().year();
            if (moment().month() > 5) {
                startYear += 1;
            }
            var gradYears = [];
            for (var i = 0; i < 10; i++) {
                var grade = 12 - i;
                var year = startYear + i;
                var displayText = "";
                if ((this.user.role & Roles.College) !== Roles.College) {
                    displayText = (grade !== 3 ? (grade !== 8 && grade !== 11 ? " - You are a " + grade + "th grade student" : " - You are an " + grade + "th grade student") : " - You are a " + grade + "rd grade student");

                }
                var gradYear = {
                    display: year + displayText,
                    value: year
                }

                gradYears.push(gradYear);

            }

            return gradYears
        };

        editRole = (): void => {
            if (this.editingDetails) {
                this.cancelEditDetails();
            }
            this.showChangePassword = false;
            this.password = {};
            this.editingRole = true;
            this.newRole = this.user.role;
        };

        saveRole = (): void => {
            this.editingRole = false;
            this.user.role = parseInt(this.newRole);
            this.user.addressVerified = true;

            var tempUser = angular.copy(this.user);

            tempUser.mailAddress = null;
            tempUser.permAddress = null;

            this.Restangular.all("users/profile/save").customPUT(tempUser)
                .then((result) => {
                    this.originalUser = this.user;
                    this.user.addressVerified = false;
                    this.log("Role Updated");

                }, (reason) => {
                    switch (reason.status) {
                        case 400:
                            if (reason.data.modelState) {
                                for (var key in reason.data.modelState) {
                                    reason.data.modelState[key].forEach((s) => {
                                        this.logError(s, s, true);
                                        this.savingDetails = false;
                                    });
                                };
                            }
                            break;
                        case 500:
                            this.logError(reason.data, reason.data, true);
                            this.savingDetails = false;
                            break;
                    }

                });
            this.gradYears = this.createGraduationYears();
        };

        editDetails = (): void => {
            this.showChangePassword = false;
            this.showChangeSecurityQuestion = false;
            this.password = {};
            this.userSecurityAnswer = "";
            this.userSecurityQuestion = this.originalUserSecurityQuestion;
            this.editingDetails = true;
            this.editingRole = false;
            if (this.user.socialSecurityNumber != '' && this.user.socialSecurityNumber != null)
                this.validateSSN(this.user.socialSecurityNumber);
            this.originalUser = _.cloneDeep(this.user);

        };

        cancelEditDetails = (): void => {
            this.editingDetails = false;
            this.validSSN = true;
            this.user = _.cloneDeep(this.originalUser);
        };


        editDemographics = (): void => {
            this.editingDemographics = true;

        };

        saveDemographics = (): void => {
            var model = _.cloneDeep(this.demographics);

            model.disabilities = this.demographics.disabilities.join(",");
            model.militaryServices = this.demographics.militaryServices.join(",");
            model.nationalities = this.demographics.nationalities.join(",");
            model.ethnicities = this.demographics.ethnicities.join(",");
            this.savingDemographics = true;

            this.Restangular.one("/users/demographics").customPUT(model)
                .then((result) => {
                    this.editingDemographics = false;
                    this.logSuccess("Your profile has been updated.", result, true);
                }, (reason) => {
                    this.logError(reason, reason, true);
                })
                .finally(() => {
                    this.savingDemographics = false;
                });

        };

        cancelEditDemographics = (): void => {
            this.demographics = _.cloneDeep(this.originalDemographics);
        };

        editParentGuardian = (): void => {
            this.editingParentGuardian = true;
        };

        saveParentGuardian = (): void => {
            this.savingParentGuardian = true;
            this.Restangular.one("/users/parentGuardianInfo").customPUT(this.parentGuardian)
                .then((result) => {
                    this.editingParentGuardian = false;
                    this.logSuccess("Your profile has been updated.", result, true);
                }, (reason) => {
                    this.logError(reason, reason, true);
                }).finally(() => {
                    this.savingParentGuardian = false;
                });
        };

        cancelEditParentGuardian = (): void => {
            this.parentGuardian = _.cloneDeep(this.originalParentGuardian);
        };

        updateSSN = (): void => {
            this.user.socialSecurityNumber = this.newSSN;
            this.displaySSN = this.newSSN;
            this.maskSSN();
        }

        maskSSN = (): void => {
            if (this.displaySSN != null && this.displaySSN != '') {
                if (this.displaySSN.contains('-')) {
                    var parts = this.displaySSN.split('-');
                    this.displaySSN = 'XXX-XX-' + parts[2];
                }
                else {
                    var final = this.displaySSN.substring(5);
                    this.displaySSN = 'XXXXX' + final;
                }
                this.editSSN = false;
            }
        }

        saveDetails = (): void => {
            this.user.graduationYear = this.selectedGradYear.value;
            this.user.role = parseInt(this.user.role)
            this.user.gender = parseInt(this.gender);
            this.savingDetails = true;
            this.user.permAddress.isVerified = false;
            this.user.mailAddress.isVerified = false;

            if (this.mailingSameAsPerm) {
                this.copyPermToMailing();
            }

            if (!this.user.addressVerified) {
                var permAddress = new Address();
                permAddress.firstName = this.user.firstName;
                permAddress.lastName = this.user.lastName;
                permAddress.street = this.user.permAddress.street;
                permAddress.street2 = null;
                permAddress.city = this.user.permAddress.city;
                permAddress.state = this.user.permAddress.state;
                permAddress.postalCode = this.user.permAddress.postalCode;
                permAddress.country = this.user.permAddress.country;
                permAddress.county = this.user.permAddress.county;
                permAddress.key = "permanent";


                var mailingAddress = new Address();
                mailingAddress.firstName = this.user.firstName
                mailingAddress.lastName = this.user.lastName;
                mailingAddress.street = this.user.mailAddress.street;
                mailingAddress.street2 = null;
                mailingAddress.city = this.user.mailAddress.city;
                mailingAddress.state = this.user.mailAddress.state;
                mailingAddress.postalCode = this.user.mailAddress.postalCode;
                mailingAddress.country = this.user.mailAddress.country;
                mailingAddress.county = this.user.mailAddress.county;
                mailingAddress.key = "mailing";

                this.addressService.validate([permAddress, mailingAddress])
                    .then((result) => {
                        result.forEach((selection) => {
                            if (selection.key == "permanent") {
                                this.user.permAddress.city = selection.city;
                                this.user.permAddress.postalCode = selection.postalCode;
                                this.user.permAddress.state = selection.state;
                                this.user.permAddress.street = selection.street;
                                this.user.permAddress.street2 = selection.street2;
                                this.user.permAddress.isVerified = selection.isVerified;
                                this.user.permAddress.userOverride = selection.userOverride;
                                this.user.permAddress.resultCodes = selection.resultCodes;
                                this.user.permAddress.signature = selection.signature;
                                this.user.permAddress.addressType = selection.addressType;
                                this.user.permAddress.country = selection.country;
                                this.user.permAddress.county = selection.county;
                            }

                            if (selection.key == "mailing") {
                                this.user.mailAddress.city = selection.city;
                                this.user.mailAddress.postalCode = selection.postalCode;
                                this.user.mailAddress.state = selection.state;
                                this.user.mailAddress.street = selection.street;
                                this.user.mailAddress.street2 = selection.street2;
                                this.user.mailAddress.isVerified = selection.isVerified;
                                this.user.mailAddress.userOverride = selection.userOverride;
                                this.user.mailAddress.resultCodes = selection.resultCodes;
                                this.user.mailAddress.signature = selection.signature;
                                this.user.mailAddress.addressType = selection.addressType;
                                this.user.mailAddress.country = selection.country;
                                this.user.mailAddress.county = selection.county;
                            }
                        });

                        this.user.addressVerified = true;
                        this.updateUser();

                    }, (reason) => {
                        reason.addresses.forEach((selection) => {
                            if (selection.key == "permanent") {
                                this.user.permAddress.city = selection.city;
                                this.user.permAddress.postalCode = selection.postalCode;
                                this.user.permAddress.state = selection.state;
                                this.user.permAddress.street = selection.street;
                                this.user.permAddress.street2 = selection.street2;
                                this.user.permAddress.signature = selection.signature;
                                this.user.permAddress.addressType = selection.addressType;
                            }

                            if (selection.key == "mailing") {
                                this.user.mailAddress.city = selection.city;
                                this.user.mailAddress.postalCode = selection.postalCode;
                                this.user.mailAddress.state = selection.state;
                                this.user.mailAddress.street = selection.street;
                                this.user.mailAddress.street2 = selection.street2;
                                this.user.mailAddress.signature = selection.signature;
                                this.user.mailAddress.addressType = selection.addressType;
                            }
                        });
                        this.savingDetails = false;
                    });
            } else {
                this.updateUser();

            }
        }

        updateUser = () => {
            this.user.role = this.formValueToBit();
            if (this.editSSN)
                this.updateSSN();
            this.Restangular.all("users/profile/save").customPUT(this.user)
                .then((result) => {
                    this.user.dateOfBirth = moment.parseZone(new Date(this.user.dateOfBirth).toUTCString()).format('MMMM DD, YYYY');
                    this.editingDetails = false;
                    this.originalUser = this.user;
                    this.user.addressVerified = false;
                    this.log("User Updated");
                    this.savingDetails = false;
                    this.logSuccess("Your profile has been updated.", result, true);
                }, (reason) => {
                    switch (reason.status) {
                        case 400:
                            if (reason.data.modelState) {
                                for (var key in reason.data.modelState) {
                                    reason.data.modelState[key].forEach((s) => {
                                        this.logError(s, s, true);
                                        this.savingDetails = false;
                                    });
                                };
                            }
                            break;
                        case 500:
                            this.logError(reason, reason.data, true);
                            this.savingDetails = false;
                            break;
                    }

                    this.savingDetails = false;
                })
        };


        changeSchool = (selectedSchool, oldPrimaryConnection?) => {
            oldPrimaryConnection = oldPrimaryConnection != null ? oldPrimaryConnection : _.cloneDeep(this.user.customer);
            this.Restangular.one("users/primaryConnection/save").customPUT(selectedSchool)
                .then((result) => {
                    this.user.primaryConnectionCrmId = selectedSchool.crmId;
                    this.user.customer = selectedSchool;
                    this.primaryConnection = selectedSchool;
                    if (selectedSchool.crmId) {
                        this.deleteConnection(selectedSchool);
                    }
                    if (oldPrimaryConnection) {
                        this.addConnection(oldPrimaryConnection);
                    }
                }, (reason) => {
                    this.logError("An error occurred changing your primary connection. Please try again.", reason, true);
                });

        };

        addConnection = (selectedSchool) => {
            var result = _.find(this.user.associatedSchools, (a: any) => {
                return a.crmId == selectedSchool.crmId;
            });

            if (!result && selectedSchool.crmId && selectedSchool.crmId != this.user.primaryConnectionCrmId) {
                this.Restangular.one("users/associatedSchools/add").customPUT(selectedSchool)
                    .then((result) => {
                        this.user.associatedSchools.push(selectedSchool);
                    }, (reason) => {
                        this.logError(reason, reason, true);
                    });
            }
        };

        deleteConnection = (school) => {
            this.Restangular.one("users/associatedSchools").customDELETE("delete", { crmId: school.crmId })
                .then((result) => {
                    _.remove(this.user.associatedSchools, (a: any) => {
                        return a.crmId == school.crmId;
                    });
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        };

        copyPermToMailing = () => {
            this.$timeout(() => {
                this.user.mailAddress.city = this.user.permAddress.city;
                this.user.mailAddress.country = this.user.permAddress.country;
                this.user.mailAddress.postalCode = this.user.permAddress.postalCode;
                this.user.mailAddress.state = this.user.permAddress.state;
                this.user.mailAddress.street = this.user.permAddress.street;
                this.user.mailAddress.street2 = this.user.permAddress.street2;
                this.user.mailingPhone = this.user.phoneNumber
                this.user.mailAddress.county = this.user.permAddress.county;
            });
        };

        changePassword = (form: ng.IFormController) => {
            this.Restangular.all("account/changepassword").post(this.password)
                .then((result) => {
                    this.showChangePassword = false;
                    this.password = {};
                    this.logSuccess("Password changed successfully", result, true);
                    form.$setUntouched();
                    form.$setPristine();

                }, (reason) => {
                    if (reason.status == 400) {
                        this.logError("Unable to change your password. Make sure your old password is typed correctly.", reason, true);

                    }
                    else {
                        this.logError("There was an error changing your password.", reason, true);
                    }
                });
        }

        cancelChangePassword = () => {
            this.showChangePassword = false;
            this.password.oldPassword = "";
            this.password.newPassword = "";
            this.password.confirmPassword = "";
        }


        verifyAddress = (address: Address): ng.IPromise<any> => {
            var defer = this.common.$q.defer();
            if (address.country === "US" || address.country === "CA") {
                defer.promise = this.Restangular.all("Address").all("Validate").post(address)
            }
            else {
                defer.resolve(null);
            }

            return defer.promise;
        };

        selectAddressOkCallback = (selectedAddress: Array<Address>) => {

            selectedAddress.forEach((selection) => {
                if (selection.key == "permanent") {
                    this.user.permAddress.city = selection.city;
                    this.user.permAddress.postalCode = selection.postalCode;
                    this.user.permAddress.state = selection.state;
                    this.user.permAddress.street = selection.street;
                    this.user.permAddress.street2 = selection.street2;
                    this.user.permAddress.isVerified = selection.isVerified;
                    this.user.permAddress.userOverride = selection.userOverride;
                    this.user.permAddress.resultCodes = selection.resultCodes;
                    this.user.permAddress.signature = selection.signature;
                    this.user.permAddress.addressType = selection.addressType;
                    this.user.permAddress.country = selection.country;
                    this.user.permAddress.county = selection.county;
                }

                if (selection.key == "mailing") {
                    this.user.mailAddress.city = selection.city;
                    this.user.mailAddress.postalCode = selection.postalCode;
                    this.user.mailAddress.state = selection.state;
                    this.user.mailAddress.street = selection.street;
                    this.user.mailAddress.street2 = selection.street2;
                    this.user.mailAddress.isVerified = selection.isVerified;
                    this.user.mailAddress.userOverride = selection.userOverride;
                    this.user.mailAddress.resultCodes = selection.resultCodes;
                    this.user.mailAddress.signature = selection.signature;
                    this.user.mailAddress.addressType = selection.addressType;
                    this.user.mailAddress.country = selection.country;
                    this.user.mailAddress.county = selection.county;
                }
            });

            this.user.addressVerified = true;
            this.saveDetails();
        };

        selectAddressCancelCallback = (selectedAddress: Array<Address>) => {
            this.mailingSameAsPerm = false;
            this.savingDetails = false;
            selectedAddress.forEach((selection) => {
                if (selection.key == "permanent") {
                    this.user.permAddress.city = selection.city;
                    this.user.permAddress.postalCode = selection.postalCode;
                    this.user.permAddress.state = selection.state;
                    this.user.permAddress.street = selection.street;
                    this.user.permAddress.street2 = selection.street2;
                    this.user.permAddress.signature = selection.signature;
                    this.user.permAddress.addressType = selection.addressType;
                }

                if (selection.key == "mailing") {
                    this.user.mailAddress.city = selection.city;
                    this.user.mailAddress.postalCode = selection.postalCode;
                    this.user.mailAddress.state = selection.state;
                    this.user.mailAddress.street = selection.street;
                    this.user.mailAddress.street2 = selection.street2;
                    this.user.mailAddress.signature = selection.signature;
                    this.user.mailAddress.addressType = selection.addressType;
                }

            });
        }

        raceToggle = (value) => {
            var idx = this.demographics.ethnicities.indexOf(value);

            if (idx > -1) {
                this.demographics.ethnicities.splice(idx, 1);
            }
            else {
                this.demographics.ethnicities.push(value);
            }
        };

        disabilityToggle = (value) => {
            var idx = this.demographics.disabilities.indexOf(value);

            if (idx > -1) {
                this.demographics.disabilities.splice(idx, 1);
            }
            else {
                this.demographics.disabilities.push(value);
            }
        };

        militaryServiceToggle = (value) => {
            var idx = this.demographics.militaryServices.indexOf(value);

            if (idx > -1) {
                this.demographics.militaryServices.splice(idx, 1);
            }
            else {
                this.demographics.militaryServices.push(value);
            }
        };

        nationalitySelected = (item, model) => {
            if (this.demographics.nationalities.length > 4) {
                var idx = this.demographics.nationalities.indexOf(item.value);
                if (idx > -1) {
                    this.demographics.nationalities.splice(idx, 1);
                }
            }
        };

        selectHispanic = () => {
            this.demographics.ethnicities = [];
        };

        getSecurityQuestion = () => {
            this.Restangular.one("account/getSecurityQuestion").get()
                .then((result) => {
                    this.userSecurityQuestion = result;
                    this.originalUserSecurityQuestion = result;
                }, (reason) => {
                    this.logError("An error occurred retrieving the security question", reason, false);
                });

        };

        saveSecurityQuestion = (form: ng.IFormController) => {
            this.Restangular.one("account/saveSecurityQuestion").customPUT({ securityQuestion: this.userSecurityQuestion, securityAnswer: this.userSecurityAnswer })
                .then((result) => {
                    this.logSuccess("Security question updated successfully", "Security question updated successfully", true);
                    this.showChangeSecurityQuestion = false;
                    this.userSecurityAnswer = "";
                    this.originalUserSecurityQuestion = this.userSecurityQuestion;
                    form.$setPristine();
                    form.$setUntouched();
                }, (reason) => {
                    this.logError("An error occurred while updating the security question", reason, true);
                });
        };

        cancelChangeSecurity = () => {
            this.showChangeSecurityQuestion = false;
            this.userSecurityAnswer = "";
            this.userSecurityQuestion = this.originalUserSecurityQuestion;
        };

        changePrimaryConnection = () => {
            if (this.user.customer.crmId != this.primaryConnection.crmId) {
                var oldPrimaryConnection = _.cloneDeep(this.user.customer);
                this.deleteConnection(this.primaryConnection);
                this.changeSchool(this.primaryConnection, oldPrimaryConnection);

            }

            this.editingPrimaryConnection = false;
        };

        cancelChangePrimaryConnection = () => {
            this.editingPrimaryConnection = false;
            this.primaryConnection = this.user.customer;
        };

        stateChanged = (property, oldValue, newValue): void => {
            if (oldValue === "NC" || newValue === "NC") {
                switch (property) {
                    case "permState":
                        this.user.permAddress.county = null;
                        break;
                    case "mailingState":
                        this.user.mailAddress.county = null;
                        break;
                }


            }
        };

        countryChanged = (property, oldValue): void => {
            if (oldValue == "US") {
                switch (property) {
                    case "permCountry":
                        this.user.permAddress.county = null;
                        break;
                    case "mailingCountry":
                        this.user.mailAddress.county = null;
                        break;
                }
            }
        }

        getCountyLabel = (value): string => {
            var county: IAddressListItem = _.find<IAddressListItem>(this.ncCounties, { value: value });

            return county == null ? value : county.label;
        };

        showTxtOptInMessage = (): void => {
            if (this.user.textingOptIns.cfnc === true) {
                var modalInstance = this.$uibModal.open({
                    templateUrl: 'template/profile/textingOptInMessage.html',
                    size: 'lg'
                });
            }

        }

        validateSSN = (ssn): void => {
            if (ssn != null && ssn != '') {
                var test = ssn.replace(/-/g, '').toString();
                var index = _.indexOf(this.invalidSSNs, test);
                if (_.startsWith(ssn, '666') || _.startsWith(ssn, '9') || index != -1) {
                    this.validSSN = false
                }
                else this.validSSN = true;
            }
        };

        getRoles = () => {
            var userRoles = this.bitToFormValue(this.user.role);
            for (let i = 0; i < userRoles.length; i++) {
                if (userRoles[i]) {
                    this.convertedRoles.push(this.roles[i]);
                }
            }
        }

        enumToBitValues = (): any[] => {
            return Object.keys(Roles).map(Number).filter(Boolean)
        };

        bitToFormValue = (bit: number): any => {
            const bits = this.enumToBitValues();
            return bits.map((b) => (bit & b) === b);
        }

        formValueToBit() {
            return this.convertedRoles.reduce((total, selected, i) => total + (selected ? selected.value : 0), 0);
        }

        checkSchoolLevels = (checkCollege: boolean): boolean => {
            if (((this.user.role & Roles.MiddleSchool) === Roles.MiddleSchool) || ((this.user.role & Roles.HighSchool) === Roles.HighSchool) || (checkCollege ? ((this.user.role & Roles.College) === Roles.College) : false)) {
                return true;
            }
            else return false;
        }

        openTwoFactorWindow = () => {
            this.$window.open(this.authUrl + "/Identity/Account/Manage/TwoFactorAuthentication", "twofactor", "height=900,width=500");
        }

        openEmailUpdateWindow = () => {
            this.$window.open(this.authUrl + "/Identity/Account/Manage/Email", "Email", "height=900,width=500");
        }
    }

    angular.module("app").controller(Profile.controllerId, Profile);




}
